import React, { Component } from 'react';
import Logo_1 from '../../image/conf/logo_bar/logos_50h_aws.jpg';
import Logo_2 from '../../image/conf/logo_bar/logos_50h_ashraebac.jpg';
import Logo_3 from '../../image/conf/logo_bar/logos_50h_atal.jpg';
import Logo_4 from '../../image/conf/logo_bar/logos_50h_colorado.jpg';
import Logo_5 from '../../image/conf/logo_bar/logos_166x50_GUT.jpg';
import Logo_6 from '../../image/conf/logo_bar/logos_166x50_hkbu.jpg';
import Logo_7 from '../../image/conf/logo_bar/logos_50h_hkstp.jpg';
import Logo_8 from '../../image/conf/logo_bar/logos_50h_huawei.jpg';
import Logo_9 from '../../image/conf/logo_bar/logos_50h_ibm.jpg';
import Logo_10 from '../../image/conf/logo_bar/logos_50h_annexebc.jpg';
import Logo_11 from '../../image/conf/logo_bar/logos_50h_microsoft.jpg';
import Logo_12 from '../../image/conf/logo_bar/logos_50h_pacific.jpg';
import Logo_13 from '../../image/conf/logo_bar/logos_166x50_PropTech.jpg';
import Logo_14 from '../../image/conf/logo_bar/logos_50h_schdl.jpg';
import Logo_15 from '../../image/conf/logo_bar/logos_50h_siemens.jpg';
import Logo_16 from '../../image/conf/logo_bar/logos_50h_tencent.jpg';
import Logo_17 from '../../image/conf/logo_bar/logos_50h_twongas.jpg';
import Logo_18 from '../../image/conf/logo_bar/logos_50h_hkpu.jpg';
import Logo_19 from '../../image/conf/logo_bar/logos_50h_veolia.jpg';
import Logo_20 from '../../image/conf/logo_bar/logos_50h_worldGreen.jpg';
import Logo_21 from '../../image/conf/logo_bar/logos_166x50_WSP.jpg';
import Logo_22 from '../../image/conf/logo_bar/logos_166x50_ZUAE.jpg';
import Logo_23 from '../../image/conf/logo_bar/logos_166x50_CIBSE.jpg';
import './rolling_logo.css';

class Rolling_Logo extends Component {
    roll(s) {
        var el = document.getElementById('rolling_logo');
        let width = window.innerWidth;
        var maxScrollLeft;
        if (width > 768) {
            maxScrollLeft = 3205;
        } else {
            maxScrollLeft = 3205 * (width / 768);
        }

        if (this.state.left) {
            if (s < 1) {
                el.scrollLeft = maxScrollLeft;
                setTimeout(() => {
                    this.setState({ time: maxScrollLeft });
                }, 0);
            } else {
                el.scrollLeft = s;
            }
        } else {
            if (s < maxScrollLeft) {
                el.scrollLeft = s;
            } else {
                el.scrollLeft = 0;
                setTimeout(() => {
                    this.setState({ time: 0 });
                }, 0);
            }
        }
    }
    start() {
        this.setState({ stop: false });
    }
    stop() {
        this.setState({ stop: true });
    }

    state = {
        time: 0,
        fast: false,
        left: false,
        stop: false,
    }
    componentDidMount() {

        setInterval(() => {
            let p = 0;
            if (this.state.stop) {
                p = this.state.time;
            } else {
                if (this.state.left) {
                    p = this.state.time - 5;
                } else {
                    if (this.state.fast) {
                        p = this.state.time + 5;
                    } else {
                        p = this.state.time + 1;
                    }
                }
            }

            this.setState({ time: p });
        }, 50)
    }
    componentDidUpdate() {
        this.roll(this.state.time);

    }

    render() {

        return (
            <div id="rolling_logo_bar" className="d-flex justify-content-center">
                <div className="d-flex align-items-center logo-arrow-box" onMouseEnter={() => { this.setState({ fast: true, left: true }); }} onMouseLeave={() => { this.setState({ fast: false, left: false }); }}>
                    <div className="logo-arrow-left"></div>
                </div>

                <div id="rolling_logo" className="d-flex" onMouseEnter={() => this.stop()} onMouseLeave={() => this.start()}>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_1} className="div-logo-type-1" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_2} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_3} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_23} className="div-logo-type-16" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_4} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_5} className="div-logo-type-3" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_6} className="div-logo-type-4" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_7} className="div-logo-type-5" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_8} className="div-logo-type-6" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_9} className="div-logo-type-7" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_10} className="div-logo-type-8" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_11} className="div-logo-type-9" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_12} className="div-logo-type-10" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_13} className="div-logo-type-8" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_14} className="div-logo-type-11" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_15} className="div-logo-type-12" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_16} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_17} className="div-logo-type-13" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_18} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_19} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_20} className="div-logo-type-14" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_21} className="div-logo-type-15" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_22} className="div-logo-type-10" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_1} className="div-logo-type-1" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_2} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_3} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_23} className="div-logo-type-16" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_4} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_5} className="div-logo-type-3" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_6} className="div-logo-type-4" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_7} className="div-logo-type-5" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_8} className="div-logo-type-6" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_9} className="div-logo-type-7" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_10} className="div-logo-type-8" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_11} className="div-logo-type-9" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_12} className="div-logo-type-10" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_13} className="div-logo-type-8" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_14} className="div-logo-type-11" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_15} className="div-logo-type-12" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_16} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_17} className="div-logo-type-13" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_18} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_19} className="div-logo-type-2" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_20} className="div-logo-type-14" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_21} className="div-logo-type-15" alt=""></img>
                    </div>
                    <div className="div-logo d-flex justify-content-center">
                        <img src={Logo_22} className="div-logo-type-10" alt=""></img>
                    </div>
                </div>

                <div className="d-flex align-items-center logo-arrow-box" onMouseEnter={() => { this.setState({ fast: true }); }} onMouseLeave={() => { this.setState({ fast: false }); }}>
                    <div className="logo-arrow-right"></div>
                </div>
            </div>
        );

    }
}
export default Rolling_Logo;



// WEBPACK FOOTER //
// ./src/components/widget/rolling_logo.js